import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import Toggle from 'react-toggle';
import Select from 'react-select';
import DesignationRequisitionComponent from './DesignationRequisitionComponent';
import getLocale from '../../../i18n/getLocale';

class DesignationRequisitionFormTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: false,
      id: this.props.designation_id,
      name: null,
      aircraft_models_list: [],
      designation_requisitions: [],
      aircraft_model_id: null,
      flight_time: null,
      commander_time: null,
      motor_time: null,
      similar_time: null,
      ifr_time: null,
      model_time: null,
      size_time: null,
      commander_model_time: null,
      commander_motor_time: null,
      exception: false,
    };

    //bind específico
    this.addRequisition = this.addRequisition.bind(this);
    this.deleteRequisiton = this.deleteRequisiton.bind(this);

    // Handlers
    this.locale = getLocale();

  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  } 
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }
  // LM
  componentWillReceiveProps(newProps) {
    this.setState({id: newProps.designation_id});
    if(Array.isArray(newProps.aircraft_models_list)) {
      this.setState({aircraft_models_list: newProps.aircraft_models_list});
    }
    if(Array.isArray(newProps.designation_requisitions)) {
      this.setState({designation_requisitions: newProps.designation_requisitions});
    }
  }

  addRequisition(event) {
    event.preventDefault();
    var datasave = {
      designation_id: this.state.id,
      name: this.state.name,
      aircraft_model_id: this.state.aircraft_model_id,
      flight_time: this.state.flight_time,
      commander_time: this.state.commander_time,
      motor_time: this.state.motor_time,
      similar_time: this.state.similar_time,
      ifr_time: this.state.ifr_time,
      model_time: this.state.model_time,
      size_time: this.state.size_time,
      commander_model_time: this.state.commander_model_time,
      commander_motor_time: this.state.commander_motor_time,
      exception: this.state.exception,
    };
    var self = this;
    self.props.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/designacao/requisicao', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.props.loadData(responseJson);
        } else {
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }


  deleteRequisiton(id) {
    if(window.confirm(this.locale.Designacoes.EditarDesignacao.tabRequisitosHorasDeVoo.deletarRequisicaoDeHoras)) {
      var self = this;
      self.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/designacao/requisicao/'+id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.props.loadData(responseJson);
          } else {
            self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          }
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }


  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <form onSubmit={this.addRequisition}> 
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.Designacoes.EditarDesignacao.tabRequisitosHorasDeVoo.formulario.Frota}:</label>
          <Select
            className="form-field-name"
            name="aircraft_model_id"
            value={this.state.aircraft_model_id}
            searchable={true}
            placeholder={this.locale.Designacoes.EditarDesignacao.tabRequisitosHorasDeVoo.formulario.placeholder.SelecionarFrota}
            onChange={this.handleSelectChange.bind(this, 'aircraft_model_id')}
            options={this.state.aircraft_models_list}
            required
          />
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.Designacoes.EditarDesignacao.tabRequisitosHorasDeVoo.formulario.TotalDeHorasDeVooEmModelosDeComplexidadeSimilar}:</label>
          <input value={this.state.similar_time} name="similar_time" className="form-control" onChange={this.handleChange.bind(this, 'similar_time')} placeholder={this.locale.Designacoes.EditarDesignacao.tabRequisitosHorasDeVoo.formulario.placeholder.TotalDeHorasDeVooEmModelosDeComplexidadeSimilar} />
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.Designacoes.EditarDesignacao.tabRequisitosHorasDeVoo.formulario.TotalGeralDeHorasDeVoo}:</label>
          <input value={this.state.flight_time} name="flight_time" className="form-control" onChange={this.handleChange.bind(this, 'flight_time')} placeholder={this.locale.Designacoes.EditarDesignacao.tabRequisitosHorasDeVoo.formulario.placeholder.TotalGeralDeHorasDeVoo} />
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.Designacoes.EditarDesignacao.tabRequisitosHorasDeVoo.formulario.TotalDeHorasDeVooNoModeloExato}:</label>
          <input value={this.state.model_time} name="model_time" className="form-control" onChange={this.handleChange.bind(this, 'model_time')} placeholder={this.locale.Designacoes.EditarDesignacao.tabRequisitosHorasDeVoo.formulario.placeholder.TotalDeHorasDeVooNoModeloExato} />
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.Designacoes.EditarDesignacao.tabRequisitosHorasDeVoo.formulario.TotalDeHorasEmComando}:</label>
          <input value={this.state.commander_time} name="commander_time" className="form-control" onChange={this.handleChange.bind(this, 'commander_time')} placeholder={this.locale.Designacoes.EditarDesignacao.tabRequisitosHorasDeVoo.formulario.placeholder.TotalDeHorasEmComando} />
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.Designacoes.EditarDesignacao.tabRequisitosHorasDeVoo.formulario.TotalDeHorasEmComandoNoModeloExato}:</label>
          <input value={this.state.commander_model_time} name="commander_model_time" className="form-control" onChange={this.handleChange.bind(this, 'commander_model_time')} placeholder={this.locale.Designacoes.EditarDesignacao.tabRequisitosHorasDeVoo.formulario.placeholder.TotalDeHorasEmComandoNoModeloExato} />
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.Designacoes.EditarDesignacao.tabRequisitosHorasDeVoo.formulario.TotalDeHorasDeVooComOTipoDeMotor}:</label>
          <input value={this.state.motor_time} name="motor_time" className="form-control" onChange={this.handleChange.bind(this, 'motor_time')} placeholder={this.locale.Designacoes.EditarDesignacao.tabRequisitosHorasDeVoo.formulario.placeholder.TotalDeHorasDeVooComOTipoDeMotor} />
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.Designacoes.EditarDesignacao.tabRequisitosHorasDeVoo.formulario.TotalDeHorasDeVooEmComandoNoTipoDeMotor}:</label>
          <input value={this.state.commander_motor_time} name="commander_motor_time" className="form-control" onChange={this.handleChange.bind(this, 'commander_motor_time')} placeholder={this.locale.Designacoes.EditarDesignacao.tabRequisitosHorasDeVoo.formulario.placeholder.TotalDeHorasDeVooEmComandoNoTipoDeMotor} />
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.Designacoes.EditarDesignacao.tabRequisitosHorasDeVoo.formulario.TotalDeHorasDeVooEmIFR}:</label>
          <input value={this.state.ifr_time} name="ifr_time" className="form-control" onChange={this.handleChange.bind(this, 'ifr_time')} placeholder={this.locale.Designacoes.EditarDesignacao.tabRequisitosHorasDeVoo.formulario.placeholder.TotalDeHorasDeVooEmIFR} />
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.Designacoes.EditarDesignacao.tabRequisitosHorasDeVoo.formulario.TotalDeHorasDeVooEmModeloDeMesmoPorte}:</label>
          <input value={this.state.size_time} name="size_time" className="form-control" onChange={this.handleChange.bind(this, 'size_time')} placeholder={this.locale.Designacoes.EditarDesignacao.tabRequisitosHorasDeVoo.formulario.placeholder.TotalDeHorasDeVooEmModeloDeMesmoPorte} />
        </div>
      </div>
    </div>
    <div className="row">
    <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.Designacoes.EditarDesignacao.tabRequisitosHorasDeVoo.formulario.Nome}:</label>
          <input value={this.state.name} name="name" className="form-control" onChange={this.handleChange.bind(this, 'name')} placeholder={this.locale.Designacoes.EditarDesignacao.tabRequisitosHorasDeVoo.formulario.placeholder.NomeDoRegistro} required />
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.Designacoes.EditarDesignacao.tabRequisitosHorasDeVoo.formulario.Excecao}:</label>
          <br/>
          <Toggle
            checked={this.state.exception}
            aria-label='No label tag'
            name="exception"
            onChange={this.handleToggleChange.bind(this, 'exception')} />
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-12">
        <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.Designacoes.EditarDesignacao.tabRequisitosHorasDeVoo.formulario.botaoAdicionarRequisito}</button>
      </div>
    </div>
  </form>
  <hr/>
  {Object.keys(self.state.designation_requisitions).map(function(k) {
    return (
      <DesignationRequisitionComponent handleAlert={self.props.handleAlert} RequestApi={self.refs.request_api} loadData={self.props.loadData} designation_id={self.state.designation_requisitions[k].designation_id} designation_requisition_id={self.state.designation_requisitions[k].id} designation_requisition={self.state.designation_requisitions[k]} certifications_list={self.props.certifications_list} deleteRequisiton={self.deleteRequisiton} />
    );
  })}
</div>
    );
  }
}

export default DesignationRequisitionFormTab;



// WEBPACK FOOTER //
// ./src/Components/Designations/Elements/DesignationRequisitionFormTab.js